import {
  generateFedexPinInputSchema,
  generateFedexPinOutputSchema,
} from "@redotech/redo-fulfillment-carrier-account-common/fedex-customer-registration";

export const generateFedexPin = {
  name: "generateFedexPin" as const,
  input: generateFedexPinInputSchema,
  output: generateFedexPinOutputSchema,
};
